var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flag == _vm.index && _vm.detailShow
    ? _c(
        "div",
        {
          staticClass: "transfers-detail",
          style: {
            height:
              _vm.transferDetail.entities && _vm.transferDetail.entities.length
                ? _vm.transferDetail.entities.length * 25 +
                  _vm.detailHeight +
                  "px"
                : _vm.detailHeight + "px"
          }
        },
        [
          _c("div", { staticClass: "transfers-detail-title" }, [
            _vm._v(_vm._s(_vm.$t("language.popup.transferDetails")))
          ]),
          _vm._v(" "),
          _vm.transferDetail.state2.status == 1
            ? _c("div", { staticClass: "detail-count" }, [
                _c("div", { staticClass: "transfer-line" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.countFiles")) +
                      ":(" +
                      _vm._s(_vm.transferDetail.state2.readyFindFileCount) +
                      _vm._s(_vm.$t("language.common.transferFiles")) +
                      "," +
                      _vm._s(
                        _vm._f("formatByte")(
                          _vm.transferDetail.state2.totalBytes
                        )
                      ) +
                      ")"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "detail-one" }, [
            _c(
              "div",
              {
                staticClass: "transfer-line",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toSourceCatalog(_vm.transferDetail.state2)
                  }
                }
              },
              [
                _c("span", { staticStyle: { float: "left" } }, [
                  _vm._v(_vm._s(_vm.$t("language.common.from")) + ":")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.transferDetail.state2.branchType !== "share",
                        expression: "transferDetail.state2.branchType!=='share'"
                      }
                    ],
                    staticClass: "catelog-color catelog-style",
                    attrs: {
                      title: _vm._f("getCatalogTitle")(
                        _vm._f("getCatalog")(
                          _vm.transferDetail.state2.sourceNode
                        )
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("getCatalog")(
                          _vm.transferDetail.state2.sourceNode
                        )
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.transferDetail.state2.branchType === "share",
                        expression: "transferDetail.state2.branchType==='share'"
                      }
                    ],
                    staticClass: "catelog-color catelog-style",
                    attrs: {
                      title: _vm._f("getCatalogTitle")(
                        _vm._f("getCatalog")(
                          _vm.transferDetail.state2.sharePath
                        )
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("ellipsis")(
                          _vm._f("getCatalog")(
                            _vm.transferDetail.state2.sharePath
                          )
                        )
                      )
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "transfer-line",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toAimCatalog(_vm.transferDetail.state2)
                  }
                }
              },
              [
                _c("span", { staticStyle: { float: "left" } }, [
                  _vm._v(_vm._s(_vm.$t("language.common.to")) + ":")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "catelog-color catelog-style",
                    attrs: {
                      title: _vm._f("getCatalogTitle")(
                        _vm._f("getCatalog")(_vm.transferDetail.state2.desNode)
                      )
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("getCatalog")(_vm.transferDetail.state2.desNode)
                      )
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "detail-two" }, [
            _c("div", { staticClass: "transfer-line" }, [
              _vm._v(
                _vm._s(_vm.$t("language.common.fileProcess")) +
                  ":\r\n            "
              ),
              _vm.transferDetail.state2.status != 0
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.transferDetail.state2.readyTranFileCount)
                    ),
                    _vm.transferDetail.state2.readyTranFileCount != null &&
                    _vm.transferDetail.state2.totalFileCount != null
                      ? _c("span", [_vm._v("/")])
                      : _vm._e(),
                    _vm._v(_vm._s(_vm.transferDetail.state2.readyFindFileCount))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "transfer-line" }, [
              _c("span", { staticClass: "transfer-column-left" }, [
                _vm._v(
                  _vm._s(_vm.$t("language.common.dataProcess")) +
                    ":\r\n                "
                ),
                _vm.transferDetail.state2.status != 0
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatByte")(
                              _vm.transferDetail.state2.readedBytes
                            )
                          ) +
                          "\r\n                "
                      ),
                      _vm.transferDetail.state2.readedBytes != null &&
                      _vm.transferDetail.state2.totalBytes != null
                        ? _c("span", [_vm._v("/")])
                        : _vm._e(),
                      _vm._v(
                        "\r\n                " +
                          _vm._s(
                            _vm._f("formatByte")(
                              _vm.transferDetail.state2.totalBytes
                            )
                          )
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "transfer-column-right" }, [
                _vm._v(_vm._s(_vm.$t("language.popup.progress")) + ":"),
                _vm.transferDetail.state2.status > 1
                  ? _c("span", [_vm._v(_vm._s(_vm.percent + "%"))])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "transfer-line" }, [
              _c("span", { staticClass: "transfer-column-left" }, [
                _vm._v(
                  _vm._s(_vm.$t("language.common.startTime")) +
                    ":\r\n                "
                ),
                _vm.transferDetail.state2.status != 0
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("transferTime")(
                            _vm.transferDetail.state2.taskStartTimeLong
                          )
                        )
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "transfer-column-right" }, [
                _vm._v(_vm._s(_vm.$t("language.common.currentRate")) + ": "),
                _vm.transferDetail.state2.status > 1
                  ? _c("span", [_vm._v(_vm._s(_vm.speed))])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.transferDetail && _vm.transferDetail.entities
            ? _c(
                "div",
                {
                  staticClass: "detail-three",
                  style: {
                    height:
                      _vm.transferDetail.entities &&
                      _vm.transferDetail.entities.length
                        ? _vm.transferDetail.entities.length * 25 + 20 + "px"
                        : "0px"
                  }
                },
                _vm._l(_vm.transferDetail.entities, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "transfer-line" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "transfer-column-left transfering-file-line",
                          attrs: { title: _vm.getTitle(item) }
                        },
                        [
                          _vm._v(
                            "\r\n                " +
                              _vm._s(_vm._f("getCatalog")(item.fileNode)) +
                              "\\" +
                              _vm._s(item.filename) +
                              "\r\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.isVip()
                        ? _c("span", [
                            item.rate == -1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "transfer-column-right transfering-file-line upgradeMulti",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.switchToPay()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.common.upgradeMulti")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.rate != -1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "transfer-column-right transfering-file-line"
                                  },
                                  [_vm._v(_vm._s(item.rate) + "%")]
                                )
                              : _vm._e()
                          ])
                        : _c("span", [
                            item.rate && item.rate != -1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "transfer-column-right transfering-file-line"
                                  },
                                  [_vm._v(_vm._s(item.rate) + "%")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "transfer-column-right transfering-file-line"
                                  },
                                  [_vm._v("0%")]
                                )
                          ])
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "detail-four" }, [
            _c("div", { staticClass: "transfer-line" }, [
              _c("div", {
                staticClass: "icon-util shop-cart shop-cart-position"
              }),
              _vm._v(" "),
              !_vm.isVip()
                ? _c("span", { staticClass: "transfer-line-des" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.noVip")))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isVip()
                ? _c("span", { staticClass: "transfer-line-des" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.vipThanks")))
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", [
            !_vm.isVip()
              ? _c("div", { staticClass: "transfer-line" }, [
                  _c(
                    "button",
                    {
                      staticClass: "upgrade-now",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.switchToPay()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.upgradeNow")))]
                  )
                ])
              : _vm._e()
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c8a940f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8a940f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_transfer_detail.vue
// module id = null
// module chunks = 